import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth.vue'),
    meta: { title: '微信授权' }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: '云海气象', requireAuth: true }
  },
  {
    path: '/forecast/city',
    name: 'CityForecast',
    component: () => import('../views/CityForecast.vue'),
    meta: { title: '城市预报', requireAuth: true }
  },
  {
    path: '/forecast/ocean',
    name: 'OceanForecast',
    component: () => import('../views/OceanForecast.vue'),
    meta: { title: '海洋预报', requireAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
    meta: { title: '后台管理' }
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes
});

const ensureAnonymousId = () => {
  const key = 'yunhai_anon_id';
  let id = localStorage.getItem(key);
  if (id) return id;
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    id = crypto.randomUUID();
  } else {
    id = `anon_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
  }
  localStorage.setItem(key, id);
  return id;
};

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '云海气象';

  const userInfo = localStorage.getItem('yunhai_user');

  if (to.meta.requireAuth && !userInfo) {
    ensureAnonymousId();
    next();
  } else {
    next();
  }
});

export default router;
